import React, { Component } from 'react';
import ButtonCompactPrimary from 'components/atoms/buttons/compact/Primary';
import IconWrapper from 'components/atoms/IconWrapper';

class ButtonIconPrimary extends Component {
    render() {
        const { children, icon, iconColor } = this.props;

        return (
            <ButtonCompactPrimary {...this.props}>
                <IconWrapper className={`icon-${icon}`} iconColor={iconColor}/>
                {children}
            </ButtonCompactPrimary>
        );
    }
}

export default ButtonIconPrimary;



// WEBPACK FOOTER //
// ./src/components/molecules/buttons/ButtonIconPrimary.js